
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import Pagination from '@mui/material/Pagination';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,

    report_08,
    report_09
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {

            loading: false,
            data: null,

            data_detail: [],

            page: 1,
            data_search: "",

            after_discount: "",
            bill_number: "",
            discount: "",
            due_date: "",
            finance_name: "",
            invoice_number: "",
            job_number: "",
            member_name: "",
            net_total_amount: "",
            payment_id: "",
            payment_number: "",
            payment_status: "",
            payment_type: "",
            product_list: [],
            remark: "",
            total_amount: "",
            total_spare: "",
            total_wage: "",
            vat: "",
            filter_vat: "",
            item: null
        }
    }
    async componentDidMount() {
        this.Get();
    }
    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            payment_id: "",
            filter_vat: this.state.filter_vat
        }
        let result = await GET(tokens, "v1/TH/payment/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data: result });
        }
        this.setState({ loading: false });
    }
    GetById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            payment_id: id
        }
        let result = await GET(tokens, "v1/TH/payment/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({
                after_discount: result.data.after_discount,
                bill_number: result.data.bill_number,
                discount: result.data.discount,
                due_date: result.data.due_date,
                finance_name: result.data.finance_name,
                invoice_number: result.data.invoice_number,
                job_number: result.data.job_number,
                member_name: result.data.member_name,
                net_total_amount: result.data.net_total_amount,
                payment_id: result.data.payment_id,
                payment_number: result.data.payment_number,
                payment_status: result.data.payment_status,
                payment_type: result.data.payment_type,
                product_list: result.data.product_list,
                remark: result.data.remark,
                total_amount: result.data.total_amount,
                total_spare: result.data.total_spare,
                total_wage: result.data.total_wage,
                vat: result.data.vat,
                item: result.data

            })
        }
        this.setState({ loading: false });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="ระบบขาย" page3="รายการชำระเงิน" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex row mx-0 align-items-center justify-content-between test">
                            <h3 className="mb-2"><b>รายการชำระเงิน</b></h3>
                        </div>
                        <div className="row mb-2 mx-0">
                            <div className="col-12 col-md-6 col-lg-3 mb-2" onClick={() => {
                                if (this.state.filter_vat === 0) {
                                    this.setState({ filter_vat: "" });
                                } else {
                                    this.setState({ filter_vat: 0 });
                                }
                                setTimeout(() => {
                                    this.Get()
                                }, 10);
                            }}>
                                <div className={this.state.filter_vat === 0 ? "card bg-primary text-white border-0 p-3 w-100 rounded" : "card bg-primary-light text-primary border-0 p-3 w-100 rounded"}>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h6><b>เอกสารไม่มีภาษี</b></h6>
                                        <h3><b>{this.state.data ? this.state.data.data.count_no_vat : "0"}</b></h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 mb-2" onClick={() => {
                                if (this.state.filter_vat === 1) {
                                    this.setState({ filter_vat: "" });
                                } else {
                                    this.setState({ filter_vat: 1 });
                                }
                                setTimeout(() => {
                                    this.Get()
                                }, 10);
                            }}>
                                <div className={this.state.filter_vat === 1 ? "card bg-primary text-white border-0 p-3 w-100 rounded" : "card bg-primary-light text-primary border-0 p-3 w-100 rounded"}>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h6><b>เอกสารมีภาษี</b></h6>
                                        <h3><b>{this.state.data ? this.state.data.data.count_vat : "0"}</b></h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-100 card border-0">
                            <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                <input
                                    className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                    onKeyUp={(e) => {
                                        if (e.key === "Enter") {
                                            this.setState({ page: 1 });
                                            setTimeout(() => {
                                                this.Get();
                                            }, 10);
                                        }
                                    }}
                                    value={this.state.data_search}
                                />
                                <button className="btn btn-orange mx-1 mb-2" onClick={() => {
                                    this.setState({ page: 1 });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    ค้นหา
                                </button>
                                <button className="btn btn-outline-orange mx-1 mb-2" onClick={() => {
                                    this.setState({ page: 1, data_search: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    รีเซ็ต
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white">เลขบิลขาย</th>
                                            <th className="text-left text-white">ชื่อลูกค้า</th>
                                            <th className="text-center text-white">วันที่ออกบิล</th>
                                            <th className="text-center text-white">กำหนดชำระเงิน</th>
                                            <th className="text-center text-white">สถานะ</th>
                                            <th className="text-center text-white">จัดการ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.data.data_list.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{item.payment_number ? item.payment_number : "-"}</td>
                                                <td className="text-left">{item.member_name ? item.member_name : "-"}</td>
                                                <td className="text-center">{item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy hh:mm") : "-"}</td>
                                                <td className="text-center">{item.due_date ? format_date(item.due_date, "dd/mm/yyyy") : "-"}</td>
                                                <td className="text-center">{item.payment_status === 1 ? "รอชำระ" : "ชำระแล้ว"}</td>
                                                <td className="text-center">
                                                    <div className="w-100 d-flex justify-content-center">

                                                        <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={async () => {
                                                                await this.GetById(item.payment_id);
                                                                this.setState({ modal_detail: true })
                                                            }}>
                                                            <label className="pointer icon text-primary p-2">{"\uf15b"}</label>
                                                        </div>
                                                        {item.payment_status === 1 && (
                                                            <div className="pointer wpx-30 hpx-30 rounded bg-warning-light mx-1 d-flex justify-content-center align-items-center"
                                                                onClick={() => { window.location.href = "/sale/sale/update?id=" + item.payment_id }}>
                                                                <label className="pointer icon text-warning p-2">{"\uf2e8"}</label>
                                                            </div>
                                                        )}
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-cyan-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={async () => {
                                                                await this.GetById(item.payment_id);
                                                                console.log(this.state.item)
                                                                if (this.state.vat) {
                                                                    report_08(this.state.item);
                                                                } else {
                                                                    report_09(this.state.item);
                                                                }
                                                            }}>
                                                            <label className="pointer icon text-cyan p-2">{"\uf02f"}</label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {/* pagination */}
                                {this.state.data && (
                                    <div className="d-flex flex-wrap justify-content-between w-100 px-3 mt-3">
                                        <label>
                                            แสดง {this.state.data.end_index} รายการ จาก {this.state.data.count} รายการ
                                        </label>
                                        <Pagination
                                            count={this.state.data.page_number}
                                            page={this.state.data.page}
                                            color="primary"
                                            showFirstButton
                                            shape="rounded"
                                            showLastButton
                                            onChange={(event, value) => {
                                                this.setState({ page: value })
                                                setTimeout(() => { this.Get() }, 5)
                                            }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* create update */}
                <Modal show={this.state.modal_detail}
                    onHide={() => { this.setState({ modal_detail: false }) }}
                    size={"lg"}>
                    <Modal.Header><Modal.Title><b>รายละเอียด</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        <div className="row mx-1">
                            <div className="col-6 mb-2 px-1">
                                <div className="card p-3 text-center rounded bg-light">
                                    <label className="text-secondary">เลขที่เอกสาร</label>
                                    <label>{this.state.payment_number}</label>
                                </div>
                            </div>
                            <div className="col-6 mb-2 px-1">
                                <div className="card p-3 text-center rounded bg-light">
                                    <label className="text-secondary">พนักงานขาย</label>
                                    <label>{this.state.finance_name}</label>
                                </div>
                            </div>
                            <div className="col-4 mb-2 px-1">
                                <div className="card p-3 text-center rounded bg-light">
                                    <label className="text-secondary">ลูกค้า</label>
                                    <label>{this.state.member_name}</label>
                                </div>
                            </div>
                            <div className="col-4 mb-2 px-1">
                                <div className="card p-3 text-center rounded bg-light">
                                    <label className="text-secondary">ประเภทชำระ</label>
                                    <label>{this.state.payment_type === 1 ? "เงินสด" : this.state.payment_type === 2 ? "เงินโอน" : this.state.payment_type === 3 ? "บัตรเครดิต" : "-"}</label>
                                </div>
                            </div>
                            <div className="col-4 mb-2 px-1">
                                <div className="card p-3 text-center rounded bg-light">
                                    <label className="text-secondary">วันและเวลา</label>
                                    <label>{this.state.due_date ? format_date(this.state.due_date, "dd mmmm yyyy hh:mm") : "-"}</label>
                                </div>
                            </div>
                        </div>
                        <div className="card border-0 rounded-lg">
                            <table className="table table-borderless">
                                <thead className="bg-primary">
                                    <tr>
                                        <th className="text-center text-white">รหัสสินค้า</th>
                                        <th className="text-center text-white">ชื่อสินค้า</th>
                                        <th className="text-center text-white">จำนวน</th>
                                        <th className="text-center text-white">ราคา/หน่วย</th>
                                        <th className="text-center text-white">จำนวนรวม</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.product_list && this.state.product_list.map((item, index) => (
                                        <tr key={index} className="border-bottom">
                                            <td className="text-center">{item.product_code ? item.product_code : "-"}</td>
                                            <td className="text-center">{item.product_name ? item.product_name : "-"}</td>
                                            <td className="text-center">{item.qty_unit ? item.qty_unit : "-"}</td>
                                            <td className="text-center">{item.price_unit ? toFixed(item.price_unit) : "-"}</td>
                                            <td className="text-center">{item.total_price ? toFixed(item.total_price) : "-"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-2"></div>
                            <div className="col-12 col-md-5">
                                <div className="d-flex justify-content-between border-bottom py-2">
                                    <label className="text-secondary">จำนวนเงินรวมอะไหล่</label>
                                    <label>{toFixed(total(this.state.product_list.filter(e => e.product_type === "อะไหล่"), "total_price"))}</label>
                                </div>
                                <div className="d-flex justify-content-between border-bottom py-2">
                                    <label className="text-secondary">จำนวนเงินรวมค่าแรง</label>
                                    <label>{toFixed(total(this.state.product_list.filter(e => e.product_type === "การซ่อม"), "total_price"))}</label>
                                </div>
                            </div>
                            <div className="col-12 col-md-5">
                                <div className="d-flex justify-content-between border-bottom py-2">
                                    <label className="text-secondary">ราคารวม</label>
                                    <label>{toFixed(this.state.total_amount)}</label>
                                </div>
                                <div className="d-flex justify-content-between border-bottom py-2">
                                    <label className="text-secondary">ส่วนลด</label>
                                    <label>{toFixed(this.state.discount)}</label>
                                </div>
                                <div className="d-flex justify-content-between border-bottom py-2">
                                    <label className="text-secondary">ราคาหลังหักส่วนลด</label>
                                    <label>{toFixed(this.state.after_discount)}</label>
                                </div>
                                <div className="d-flex justify-content-between border-bottom py-2">
                                    <label className="text-secondary">ภาษี 7%</label>
                                    <label>{toFixed(this.state.vat)}</label>
                                </div>
                                <div className="d-flex justify-content-between border-bottom py-2">
                                    <label className="text-secondary">ยอดรวมสุทธิ</label>
                                    <label>{toFixed(this.state.net_total_amount)}</label>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex justify-content-center">
                            <button className="btn btn-orange" onClick={() => { this.setState({ modal_detail: false }) }}>
                                ตกลง
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
